import {
    CardWrapper,
    ImageContainer,
    Name,
    Position,
    Rating,
    Review,
    CardContentWrapper,
} from '../styles';
import Image from 'next/image';
import { getImageBasePath } from '@utils/generics';

interface IProps {
    avatar: string;
    name: string;
    position: string;
    review: string;
}

const Card = (props: IProps) => {
    const { avatar, name, position, review } = props;

    return (
        <CardWrapper>
            <ImageContainer>
                <Image
                    src={getImageBasePath(avatar)}
                    height="130px"
                    width="130px"
                />
            </ImageContainer>
            <CardContentWrapper>
                <Name>{name}</Name>
                <Position>{position}</Position>
                <Rating>
                    <Image
                        height="18px"
                        width="104px"
                        src={getImageBasePath('/images/rating.svg')}
                    />
                </Rating>
                <Review>{review}</Review>
            </CardContentWrapper>
        </CardWrapper>
    );
};

export default Card;
